
import { useContext, ref } from '@nuxtjs/composition-api';
import { commonInputAttrs } from './shared'
import { useEmailValidation } from '@/composable/validation/useEmailValidation'
import useTlmCart from '@/composable/useTlmCart';
import useTracking from '~/composable/tracking/useTracking';

export default {
  emits: ['valid'],
  setup(_props, ctx) {
    const { trackFieldError, trackFieldRule } = useTracking()
    const { errors, validate, loading, messages, valid } = useEmailValidation()
    const { app } = useContext()
    const { getCartID } = useTlmCart(app)
    // const emailRegex = /.+@.+\..+/
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/

    const email = ref(null)

    const validateEmail = async (v) => {
      if (!v.length) { return }
      await validate(v, getCartID.value)
      ctx.emit('valid', valid.value)
    }

    const onInput = v => {
      ctx.emit('input', v)
      if (email.value?.validate()) {
        validateEmail(v)
      }
    }

    return {
      onInput,
      email,
      loading,
      errors,
      messages,

      emailRules: [
        v => !!v || trackFieldRule({ message: 'Du skal angive din e-mail', fieldName: 'email' }),
        v => emailRegex.test(v) || trackFieldRule({ message: 'Du skal angive en gyldig e-mail adresse', fieldName: 'email' })
      ],

      commonInputAttrs,
      trackFieldError,
      validateEmail
    }
  }
}
